<!-- Modal -->
<div class="gs-overlay" *ngIf="abierto" (click)="cerrar()">
  <div class="gs-modal" (click)="$event.stopPropagation()" role="dialog" aria-modal="true" aria-label="Buscador">
    <!-- Caja de búsqueda -->
    <div class="gs-searchbox">
      <i class="bi bi-search gs-searchbox-icon"></i>
      <input
        #searchInput
        type="text"
        class="gs-input"
        placeholder="Busca seguros, sucursales, noticias…"
        [(ngModel)]="query"
        (input)="onInput()"
        autocomplete="off"
        spellcheck="false"
      />
      <span class="gs-spinner" *ngIf="cargando"></span>
      <button type="button" class="gs-close" (click)="cerrar()" aria-label="Cerrar">Esc</button>
    </div>

    <!-- Resultados -->
    <div class="gs-results">
      <ng-container *ngIf="grupos.length; else estados">
        <div class="gs-group" *ngFor="let grupo of grupos">
          <div class="gs-group-title">{{ grupo.categoria }}</div>
          <a
            *ngFor="let hit of grupo.hits; trackBy: trackHit"
            class="gs-result"
            (click)="irA(hit)"
          >
            <span class="gs-result-icon"><i class="bi bi-arrow-return-right"></i></span>
            <span class="gs-result-body">
              <span class="gs-result-title" [innerHTML]="resaltado(hit, 'titulo')"></span>
              <span class="gs-result-desc" [innerHTML]="resaltado(hit, 'descripcion')"></span>
            </span>
          </a>
        </div>
      </ng-container>

      <ng-template #estados>
        <div class="gs-empty" *ngIf="buscado && !cargando">
          No se encontraron resultados para <strong>"{{ query }}"</strong>.
        </div>
        <div class="gs-hint" *ngIf="!buscado && !cargando">
          Escribe para buscar en todo el contenido de TC Brokers.
        </div>
      </ng-template>
    </div>

    <!-- Pie -->
    <div class="gs-footer">
      <span><kbd>esc</kbd> para cerrar</span>
      <span class="gs-footer-brand">Tocars Brokers</span>
    </div>
  </div>
</div>
